export default "__VITE_ASSET__D3sb5Hdq__"